// @ts-nocheck
 
 
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps, import/no-extraneous-dependencies */
 
/* eslint-disable react/jsx-newline */
 
 
 
/* eslint-disable no-nested-ternary */
 
 
import axios from "axios";
import React, { Fragment, useEffect, useRef, useState , Suspense } from 'react'

import { Link, NavLink, useHistory } from "react-router-dom";
//import NavBar from '../components/NavBar';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next'
import "../style.css";
//import Sidebar from '../components/Sidebar';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import SearchIcon from '@mui/icons-material/Search';
import cookies from 'js-cookie'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import Loading from "../images/loading2.svg";
import ClearIcon from '@mui/icons-material/Clear';
import UploadFileIcon from '@mui/icons-material/UploadFile';

import {
  Button,
  CircularProgress,
  Popover,
  Typography,

  createStyles,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,

} from '@material-ui/core';

import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';
import { TextCell } from 'app/components/shared/table';

import { default as ReactSelect , components } from "react-select";
import AdUnitsIcon from '@mui/icons-material/AdUnits';

import { Box } from '@mui/material';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useIntl } from 'react-intl';
import { useGetFilterOrganizations } from 'hooks';
import { useGetFilterGroups } from 'hooks/useGetFilterGroups';
import { useTypedSelector } from 'helpers';
import { useSelector } from 'react-redux';
import { log } from 'console';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { hasWriteAccessToMasterConfigSubSystem } from "selectors";
import StyleIcon from '@mui/icons-material/Style';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import { styled } from '@mui/system';
const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
  })
);

// Custom styled components
const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#F0642C', // Change the color of the indicator line
  },
});

const StyledTab = styled(Tab)(({ theme }) => ({
  color: "#363740",
   fontWeight: 'bold',
   margin:" 0 20px",
   textTransform:"capitalize",
   borderRadius:"10px",
  '&.Mui-selected': {
    color: "#F0642C"
  },
 /* '&:hover': {
    color: "yellow",
  },*/
}));
const OperationsReportsPage: React.FC = () => {
  const intl = useIntl();
  const classes = useStyles();
  const history = useHistory();
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us' //	ar-eg
  const [organisations, setOrganisations] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let userAuthData = '';
  const authData = localStorage.getItem('authData');
  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    userAuthData = parsedAuthData.userToken;
  }
  const [value, setValue] = React.useState(0);
  const [orgCode, setOrgCode] = useState(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
const [selectedOrg, setSelectedOrg] = useState('');

  const handleOrgChange = (value) => {
    setSelectedOrg(value);
    setOrgCode(value)
  };

  const fetchOrganisations = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`, {
        headers: {
          'access-token': userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      setOrganisations(response.data.data);
    } catch (error) {
      toast.error(`Failed to get organisations [${error}]`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganisations();
  }, []);
  //not used
  /*const [iFrameError, setIFrameError] = useState(false);
  const [iframeSrc, setIframeSrc] = useState(null);
  let checking_link = (link) => {
  fetch(link, { mode: 'no-cors' })
    .then(() => {
      // If the fetch succeeds, set the iframe's src
      setIframeSrc(link);
      setIFrameError(false);
    })
    .catch((err) => {
      setIframeSrc(link);
      console.error('Error loading URL:', err);
      setIFrameError(true);
    })}*/
  return (
    <div className='dev-contain-all-page-content'>
      <h2 className='header-of-subsystem-page'>
        <EqualizerIcon style={{ margin: "10px  10px 13px 10px", fontSize: "28px" }} />
        {intl.formatMessage({ id: 'OperationsReports' })}
      </h2>
      {userAuthData ?
        <>
         <div className="availabe-org" >
       
                   {
                     isLoading ? (
       
                       <div style={{ textAlign: "center", margin: "10px" }}>
                         <CircularProgress style={{ width: "50px" }} />
                       </div>
       
                     ) :
       
                       organisations && organisations.length > 0 ? (
       
                         <>
                           <label className='labelStyle' style={{ margin:"15px" }} >{intl.formatMessage({ id: 'organization' })}</label>
                           <select
                             className='inputStyle'
                             id="organisations"
                             value={selectedOrg}
                             onChange={(e) => handleOrgChange(e.target.value)}
                           >
                             {
                               organisations.map((organisation) => (
                                 <option key={organisation.id} value={organisation.org_code}>
                                   {currentLanguageCode === 'en-us' ? organisation.en_name : organisation.ar_name}
                                 </option>
                               ))
                             }
                           </select>
       
                         </>
       
                       ) : (
                         <div style={{ textAlign: 'center', padding: '15px' }}>
                           {intl.formatMessage({ id: 'somethingWrong' })}
                         </div>
                       )}
       
                 </div>
          <div className="bi-div">
            {
              isLoading ? (
                <div style={{ textAlign: "center", margin: "10px" }}>
                  <CircularProgress style={{ width: "50px" }} />
                </div>
              ) :
                organisations && organisations?.length > 0  ?
                  <iframe src={
                     `https://bi.avl.${orgCode == null ? organisations[0].org_code : orgCode}.mwasla.tech`
                  } style={{ width: "100%", height: "530px" }} title="Iframe Example"
                  />                  
                  :
                  <h3 style={{ textAlign: "center", margin: "10px" }}>{intl.formatMessage({ id: 'NoDateAvailable' })}</h3>
            }
          </div>
        </> : <h2>
          <center> {intl.formatMessage({ id: 'LoginAgain' })} </center>
        </h2>}
    </div>
  )
}

export default OperationsReportsPage